// pk模式的store
const localRobot = JSON.parse(localStorage.getItem('robot')) || {
  nickname: '',
  avatar: '',
}
const state = (() => {
  return {
    robot: {
      nickname: localRobot.nickname,
      avatar: localRobot.avatar
    }
  }
})

const mutations = {
  setRobot(state, payload) {
    state.robot.nickname = payload.nickname
    state.robot.avatar = payload.avatar

    // 本地化存储
    localStorage.setItem('robot', JSON.stringify(state.robot))
  }
}

const getters = {
  getRobot(state, rootState) {
    return state.robot
  }
}

export default {
  state,
  mutations,
  getters
}